import { PrefixType } from '../../redux/interfaces/Prefix'
import { Column } from '../../interfaces/Column'
import { ColumnsStorage } from '../interfaces/ColumnsStorage'

export const getActiveColumns = (prefix: PrefixType, dataType: string): ColumnsStorage[] =>
    JSON.parse(localStorage.getItem(`${prefix}_${dataType}_columns`) ?? '[]')

const setActiveColumns = (prefix: PrefixType, dataType: string, columns: ColumnsStorage[]): void => {
    localStorage.setItem(`${prefix}_${dataType}_columns`, JSON.stringify(columns))
}

export const switchColumns = (prefix: PrefixType, dataType: string, idColumns: string): ColumnsStorage[] => {
    const activeColumns = getActiveColumns(prefix, dataType)
    activeColumns.map((col) => {
        if (col.id === idColumns) {
            col.show = !col.show
        }
        return col
    })
    setActiveColumns(prefix, dataType, activeColumns)
    return activeColumns
}

export const initColumns = (prefix: PrefixType, dataType: string, columns: Column[]): ColumnsStorage[] => {
    const columnsStorage: ColumnsStorage[] = columns.map((col) => ({ name: col.name, id: col.id, show: col.show }))
    setActiveColumns(prefix, dataType, columnsStorage)
    return columnsStorage
}

export const filtreColumns = (columns: Column[], columnsList: ColumnsStorage[]): Column[] => {
    if (columnsList.length > 0) {
        return columns.filter((column) => columnsList.find((col) => col.id === column.id).show)
    }
    return []
}
